import http from "../http";

const headers = {
  headers: {
    "x-invocation-id": "",
    "x-invocation-source": ""
  }
};

export async function postBusinessMatch(config, invocationId, invocationSource) {
  headers.headers["x-invocation-id"] = invocationId;
  headers.headers["x-invocation-source"] = invocationSource;
  const response = await http.post("/partner-service-proxy/biz-advance-matching", config, headers);
  return response.data;
}

export async function getLookupMapping() {
  const response = await http.get("/biz-lookup-pretty-name-mapping");
  return response.data;
}

export async function getBusinessLookupSearchHistory(config) {
  const response = await http.get("/biz-lookup-search-history", config);
  return response.data;
}

export async function postBusinessLookupSearchHistory(config, invocationId, invocationSource) {
  headers.headers["x-invocation-id"] = invocationId;
  headers.headers["x-invocation-source"] = invocationSource;
  const response = await http.post("/biz-lookup-search-history", config, headers);
  return response.data;
}

export async function downloadReport(data, invocationId, invocationSource) {
  headers.headers["x-invocation-id"] = invocationId;
  headers.headers["x-invocation-source"] = invocationSource;
  const response = await http.post("/biz-lookup-download-report", data, headers);
  return response.data;
}

export async function getData(config, nameMatchingData, invocationId, invocationSource, contractTermsdata) {
  headers.headers["x-invocation-id"] = invocationId;
  headers.headers["x-invocation-source"] = invocationSource;

  const apiRequests = [
    {
      name: "bizFirmographic",
      condition: contractTermsdata.bizFirmograhicEnabled,
      url: "/partner-service-proxy/biz-firmographics",
      headers: headers,
      payload: config
    },
    {
      name: "bizHealth",
      condition: contractTermsdata.bizHealthEnabled,
      url: "/partner-service-proxy/biz-health",
      headers: headers,
      payload: config
    },
    {
      name: "bizCompliance",
      condition: contractTermsdata.bizComplianceEnabled,
      url: "/partner-service-proxy/biz-compliance",
      headers: headers,
      payload: config
    },
    {
      name: "bizHierarchy",
      condition: contractTermsdata.bizHeirarchyEnabled,
      url: "/partner-service-proxy/biz-heirarchy",
      headers: headers,
      payload: config
    },
    {
      name: "bizDiversity",
      condition: contractTermsdata.bizDiversityEnabled,
      url: "/partner-service-proxy/biz-diversity",
      headers: headers,
      payload: config
    },
    {
      name: "officersNameMatching",
      condition: contractTermsdata.officerNameMatchingEnabled,
      url: "/partner-service-proxy/officer-name-matching",
      headers: headers,
      payload: nameMatchingData
    }
  ];

  const apiResponses = {};

  await Promise.all(
    apiRequests.map(async (apiRequest) => {
      if (apiRequest.condition) {
        try {
          let response = await http.post(apiRequest.url, apiRequest.payload, apiRequest.headers);
          response.data.markaaz.showRetry = response.status !== 200 && response.status !== 207;

          apiResponses[apiRequest.name] = response.data.markaaz;

          if (apiRequest.name === "bizFirmographic") apiResponses["bizOverview"] = response.data.markaaz;
        } catch (error) {
          apiResponses[apiRequest.name] = {
            error: true,
            markaaz: null
          };
        }
      } else {
        apiResponses[apiRequest.name] = {
          markaaz: null
        };
      }
    })
  );

  return apiResponses;
}
